/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ControlcenterMelcoModelsBoolResponse,
    ControlcenterMelcoModelsBoolResponseFromJSON,
    ControlcenterMelcoModelsBoolResponseToJSON,
    ControlcenterMelcoModelsCancelSerialNumber,
    ControlcenterMelcoModelsCancelSerialNumberFromJSON,
    ControlcenterMelcoModelsCancelSerialNumberToJSON,
    ControlcenterMelcoModelsError,
    ControlcenterMelcoModelsErrorFromJSON,
    ControlcenterMelcoModelsErrorToJSON,
    ControlcenterMelcoModelsGenerateSerialNumber,
    ControlcenterMelcoModelsGenerateSerialNumberFromJSON,
    ControlcenterMelcoModelsGenerateSerialNumberToJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItem,
    ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItemFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItemToJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistory,
    ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistoryFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistoryToJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem,
    ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItemToJSON,
    ControlcenterMelcoModelsPendingTransaction,
    ControlcenterMelcoModelsPendingTransactionFromJSON,
    ControlcenterMelcoModelsPendingTransactionToJSON,
    ControlcenterMelcoModelsTransferSerialNumber,
    ControlcenterMelcoModelsTransferSerialNumberFromJSON,
    ControlcenterMelcoModelsTransferSerialNumberToJSON,
    ControlcenterMelcoModelsUserSerialNumber,
    ControlcenterMelcoModelsUserSerialNumberFromJSON,
    ControlcenterMelcoModelsUserSerialNumberToJSON,
} from '../models';

export interface LicensesApiCancelSerialNumberRequest {
    serialNumber: string;
    controlcenterMelcoModelsCancelSerialNumber?: ControlcenterMelcoModelsCancelSerialNumber;
}

export interface LicensesApiExportSerialNumberRequest {
    searchText?: string;
    serialNumber?: string;
    productCodes?: string;
    subscriptionCode?: string;
    referralCode?: string;
    batch?: string;
    cancelled?: string;
    offset?: number;
    limit?: number;
    sortBy?: string;
    versionId?: string;
}

export interface LicensesApiGenerateSerialNumberRequest {
    controlcenterMelcoModelsGenerateSerialNumber?: ControlcenterMelcoModelsGenerateSerialNumber;
}

export interface LicensesApiGetBySerialNumberRequest {
    serialNumber: string;
}

export interface LicensesApiGetHistoryBySerialNumberRequest {
    serialNumber: string;
}

export interface LicensesApiLicensesMachinePendingChangesRequest {
    transactionId: string;
}

export interface LicensesApiLicensesMachineSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    productList?: string;
    userName?: string;
    licenseKey?: string;
    expiresStartDate?: Date;
    expiresEndDate?: Date;
    renewsStartDate?: Date;
    renewsEndDate?: Date;
    subType?: string;
    transactionId?: string;
    status?: string;
}

export interface LicensesApiResendEmailSerialNumberRequest {
    serialNumber: string;
}

export interface LicensesApiSearchSerialNumberRequest {
    searchText?: string;
    serialNumber?: string;
    productCodes?: string;
    subscriptionCode?: string;
    referralCode?: string;
    batch?: string;
    cancelled?: string;
    offset?: number;
    limit?: number;
    sortBy?: string;
    versionId?: string;
    typeList?: string;
    userName?: string;
}

export interface LicensesApiTransferSerialNumberRequest {
    controlcenterMelcoModelsTransferSerialNumber?: ControlcenterMelcoModelsTransferSerialNumber;
}

/**
 * 
 */
export class LicensesApi extends runtime.BaseAPI {

    /**
     */
    async cancelSerialNumberRaw(requestParameters: LicensesApiCancelSerialNumberRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsBoolResponse>> {
        if (requestParameters.serialNumber === null || requestParameters.serialNumber === undefined) {
            throw new runtime.RequiredError('serialNumber','Required parameter requestParameters.serialNumber was null or undefined when calling cancelSerialNumber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/manage/license/{serial_number}/cancel`.replace(`{${"serial_number"}}`, encodeURIComponent(String(requestParameters.serialNumber))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ControlcenterMelcoModelsCancelSerialNumberToJSON(requestParameters.controlcenterMelcoModelsCancelSerialNumber),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async cancelSerialNumber(requestParameters: LicensesApiCancelSerialNumberRequest): Promise<ControlcenterMelcoModelsBoolResponse> {
        const response = await this.cancelSerialNumberRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async exportSerialNumberRaw(requestParameters: LicensesApiExportSerialNumberRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.serialNumber !== undefined) {
            queryParameters['serial_number'] = requestParameters.serialNumber;
        }

        if (requestParameters.productCodes !== undefined) {
            queryParameters['product_codes'] = requestParameters.productCodes;
        }

        if (requestParameters.subscriptionCode !== undefined) {
            queryParameters['subscription_code'] = requestParameters.subscriptionCode;
        }

        if (requestParameters.referralCode !== undefined) {
            queryParameters['referral_code'] = requestParameters.referralCode;
        }

        if (requestParameters.batch !== undefined) {
            queryParameters['batch'] = requestParameters.batch;
        }

        if (requestParameters.cancelled !== undefined) {
            queryParameters['cancelled'] = requestParameters.cancelled;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.versionId !== undefined) {
            queryParameters['version_id'] = requestParameters.versionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/license/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async exportSerialNumber(requestParameters: LicensesApiExportSerialNumberRequest): Promise<Blob> {
        const response = await this.exportSerialNumberRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async generateSerialNumberRaw(requestParameters: LicensesApiGenerateSerialNumberRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/manage/license`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ControlcenterMelcoModelsGenerateSerialNumberToJSON(requestParameters.controlcenterMelcoModelsGenerateSerialNumber),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSON(jsonValue));
    }

    /**
     */
    async generateSerialNumber(requestParameters: LicensesApiGenerateSerialNumberRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem> {
        const response = await this.generateSerialNumberRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getBySerialNumberRaw(requestParameters: LicensesApiGetBySerialNumberRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsUserSerialNumber>> {
        if (requestParameters.serialNumber === null || requestParameters.serialNumber === undefined) {
            throw new runtime.RequiredError('serialNumber','Required parameter requestParameters.serialNumber was null or undefined when calling getBySerialNumber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/license/{serial_number}`.replace(`{${"serial_number"}}`, encodeURIComponent(String(requestParameters.serialNumber))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsUserSerialNumberFromJSON(jsonValue));
    }

    /**
     */
    async getBySerialNumber(requestParameters: LicensesApiGetBySerialNumberRequest): Promise<ControlcenterMelcoModelsUserSerialNumber> {
        const response = await this.getBySerialNumberRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getHistoryBySerialNumberRaw(requestParameters: LicensesApiGetHistoryBySerialNumberRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistory>> {
        if (requestParameters.serialNumber === null || requestParameters.serialNumber === undefined) {
            throw new runtime.RequiredError('serialNumber','Required parameter requestParameters.serialNumber was null or undefined when calling getHistoryBySerialNumber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/license/{serial_number}/history`.replace(`{${"serial_number"}}`, encodeURIComponent(String(requestParameters.serialNumber))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistoryFromJSON(jsonValue));
    }

    /**
     */
    async getHistoryBySerialNumber(requestParameters: LicensesApiGetHistoryBySerialNumberRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistory> {
        const response = await this.getHistoryBySerialNumberRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async licensesMachinePendingChangesRaw(requestParameters: LicensesApiLicensesMachinePendingChangesRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsPendingTransaction>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling licensesMachinePendingChanges.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/license/machines/pending_changes/{transaction_id}`.replace(`{${"transaction_id"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsPendingTransactionFromJSON(jsonValue));
    }

    /**
     */
    async licensesMachinePendingChanges(requestParameters: LicensesApiLicensesMachinePendingChangesRequest): Promise<ControlcenterMelcoModelsPendingTransaction> {
        const response = await this.licensesMachinePendingChangesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async licensesMachineSearchRaw(requestParameters: LicensesApiLicensesMachineSearchRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.productList !== undefined) {
            queryParameters['product_list'] = requestParameters.productList;
        }

        if (requestParameters.userName !== undefined) {
            queryParameters['user_name'] = requestParameters.userName;
        }

        if (requestParameters.licenseKey !== undefined) {
            queryParameters['license_key'] = requestParameters.licenseKey;
        }

        if (requestParameters.expiresStartDate !== undefined) {
            queryParameters['expires_start_date'] = (requestParameters.expiresStartDate as any).toISOString();
        }

        if (requestParameters.expiresEndDate !== undefined) {
            queryParameters['expires_end_date'] = (requestParameters.expiresEndDate as any).toISOString();
        }

        if (requestParameters.renewsStartDate !== undefined) {
            queryParameters['renews_start_date'] = (requestParameters.renewsStartDate as any).toISOString();
        }

        if (requestParameters.renewsEndDate !== undefined) {
            queryParameters['renews_end_date'] = (requestParameters.renewsEndDate as any).toISOString();
        }

        if (requestParameters.subType !== undefined) {
            queryParameters['sub_type'] = requestParameters.subType;
        }

        if (requestParameters.transactionId !== undefined) {
            queryParameters['transaction_id'] = requestParameters.transactionId;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/license/machines/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItemFromJSON(jsonValue));
    }

    /**
     */
    async licensesMachineSearch(requestParameters: LicensesApiLicensesMachineSearchRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItem> {
        const response = await this.licensesMachineSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async resendEmailSerialNumberRaw(requestParameters: LicensesApiResendEmailSerialNumberRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsBoolResponse>> {
        if (requestParameters.serialNumber === null || requestParameters.serialNumber === undefined) {
            throw new runtime.RequiredError('serialNumber','Required parameter requestParameters.serialNumber was null or undefined when calling resendEmailSerialNumber.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/license/{serial_number}/resend_email`.replace(`{${"serial_number"}}`, encodeURIComponent(String(requestParameters.serialNumber))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async resendEmailSerialNumber(requestParameters: LicensesApiResendEmailSerialNumberRequest): Promise<ControlcenterMelcoModelsBoolResponse> {
        const response = await this.resendEmailSerialNumberRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async searchSerialNumberRaw(requestParameters: LicensesApiSearchSerialNumberRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.serialNumber !== undefined) {
            queryParameters['serial_number'] = requestParameters.serialNumber;
        }

        if (requestParameters.productCodes !== undefined) {
            queryParameters['product_codes'] = requestParameters.productCodes;
        }

        if (requestParameters.subscriptionCode !== undefined) {
            queryParameters['subscription_code'] = requestParameters.subscriptionCode;
        }

        if (requestParameters.referralCode !== undefined) {
            queryParameters['referral_code'] = requestParameters.referralCode;
        }

        if (requestParameters.batch !== undefined) {
            queryParameters['batch'] = requestParameters.batch;
        }

        if (requestParameters.cancelled !== undefined) {
            queryParameters['cancelled'] = requestParameters.cancelled;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.versionId !== undefined) {
            queryParameters['version_id'] = requestParameters.versionId;
        }

        if (requestParameters.typeList !== undefined) {
            queryParameters['type_list'] = requestParameters.typeList;
        }

        if (requestParameters.userName !== undefined) {
            queryParameters['user_name'] = requestParameters.userName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/license`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSON(jsonValue));
    }

    /**
     */
    async searchSerialNumber(requestParameters: LicensesApiSearchSerialNumberRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem> {
        const response = await this.searchSerialNumberRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async transferSerialNumberRaw(requestParameters: LicensesApiTransferSerialNumberRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsBoolResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/manage/license/transfer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ControlcenterMelcoModelsTransferSerialNumberToJSON(requestParameters.controlcenterMelcoModelsTransferSerialNumber),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async transferSerialNumber(requestParameters: LicensesApiTransferSerialNumberRequest): Promise<ControlcenterMelcoModelsBoolResponse> {
        const response = await this.transferSerialNumberRaw(requestParameters);
        return await response.value();
    }

}
